import { storage } from "@/utils";

export function exitWindow() {
  window.location.href = "hybird://method/exit?refresh=0";
}
export function hideTitleBar() {
  if (["/tarc/app/protocol"].includes(window.location.pathname)) {
    // APP协议页面
    const sourceDevice = storage.get("sourceDevice");
    if (["iPhoneNewStudent"].includes(sourceDevice)) {
      // 小盒学生iOS APP采用原生头部，无需调用隐藏协议
      return;
    }
  }
  window.location.href = "hybird://method/hideTitleBar?isHiden=1";
}
// 通知端内刷新tab，不展示完善信息弹框
export function tabRefresh() {
  window.location.href = "hybird://method/tabRefresh";
}
// 端内退出
export function logoutApp() {
  window.location.href = "hybird://method/logout";
}
export function openNewWindow(
  url,
  title,
  hideTitleBar = true,
  slidable = true,
) {
  let originPath = "";
  if (url.includes("tarc") || url.includes("/ce/m")) {
    originPath = window.location.origin;
  } else {
    originPath = window.location.origin + window.location.pathname;
  }
  let fullPath;
  url = originPath + url;
  if (hideTitleBar) {
    if (url.includes("?")) {
      url = url + "&hideTitleBar=true";
    } else {
      url = url + "?hideTitleBar=true";
    }
  }
  if (title) {
    url = url + `&title=${title}`;
  }
  if (slidable) {
    url = url + "&slidable=false";
  }
  fullPath = `hybird://method/openNewWindow?url=${encodeURIComponent(url)}`;
  window.location.href = fullPath;
}
export default {
  exitWindow,
  hideTitleBar,
  openNewWindow,
};
